import Wrapper from './Wrapper';
export default {
  Wrapper,
  WrapperRow:Wrapper,
  WrapperContent:Wrapper
};



// WEBPACK FOOTER //
// ./src/editor/layout/addons/select/index.js